import { FC } from 'react';

import {
  Divider,
  Typography,
} from '@beeline/design-system-react/extracted-styles';
import { Link } from '@beeline/lk-utils';

import { Column } from 'src/components/Column/Column';
import { Truncate } from 'src/components/Truncate/Truncate';

import { BookingCardComponentProps } from '../types';

import classes from './MobileBookingCard.module.scss';

export const MobileBookingCard: FC<BookingCardComponentProps> = ({
  link,
  title,
  place,
  date,
  time,
}) => {
  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <div className={classes.linkContainer}>
          {link ? (
            <Link
              navigationType='inner'
              to={link}
              className={classes.link}
              data-testid='bookingTitle'
            >
              {title}
            </Link>
          ) : (
            <Typography variant='body2' ellipsis>
              {title}
            </Typography>
          )}
        </div>
      </div>
      <Divider />
      <Column
        title='Место бронирования'
        content={<Truncate variant='body3'>{place}</Truncate>}
        testId='bookingPlace'
      />
      <Column
        title='Дата'
        content={<Truncate variant='body3'>{date}</Truncate>}
        testId='bookingDate'
      />
      {time && (
        <Column
          title='Время'
          content={<Truncate variant='body3'>{time}</Truncate>}
          testId='bookingTime'
        />
      )}
    </div>
  );
};
